/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './Metadata';
import type { ReserveClubhouseRequest } from './ReserveClubhouseRequest';
import {
    ReserveClubhouseRequestFromJSON,
    ReserveClubhouseRequestFromJSONTyped,
    ReserveClubhouseRequestToJSON,
} from './ReserveClubhouseRequest';

/**
 * 
 * @export
 * @interface ListRequestsForAccount200Response
 */
export interface ListRequestsForAccount200Response {
    /**
     * 
     * @type {Array<ReserveClubhouseRequest>}
     * @memberof ListRequestsForAccount200Response
     */
    data: Array<ReserveClubhouseRequest>;
    /**
     * 
     * @type {Metadata}
     * @memberof ListRequestsForAccount200Response
     */
    metadata: Metadata;
}

/**
 * Check if a given object implements the ListRequestsForAccount200Response interface.
 */
export function instanceOfListRequestsForAccount200Response(value: object): value is ListRequestsForAccount200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function ListRequestsForAccount200ResponseFromJSON(json: any): ListRequestsForAccount200Response {
    return ListRequestsForAccount200ResponseFromJSONTyped(json, false);
}

export function ListRequestsForAccount200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListRequestsForAccount200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ReserveClubhouseRequestFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function ListRequestsForAccount200ResponseToJSON(value?: ListRequestsForAccount200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(ReserveClubhouseRequestToJSON)),
        'metadata': MetadataToJSON(value['metadata']),
    };
}

